import { useEffect } from "react";
import { Link } from "react-router-dom";
import ReactGA from "react-ga4";
import { Helmet } from "react-helmet";

const NotFound = ({ message }: { message?: string }) => {
  return (
    <div className="container">
      <Helmet>
        <title>Page Not Found | Recipe Finder</title>
        <meta
          name="description"
          content={
            message || "The page you were looking for could not be found."
          }
        />
      </Helmet>

      <h2>{message ? message : "Page not found"}</h2>
      <p>
        Go back to the <Link to="/">recipes</Link> page
      </p>
    </div>
  );
};

export default NotFound;
